// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warehouse-transfers-wrap {
  position: relative;
  width: auto;
  display: block;
  padding: 30px;
}
.warehouse-transfers-wrap .thirty-padding {
  padding: 0 !important;
}
.warehouse-transfers-wrap .thirty-padding .cp-lg-obj-wrap {
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/inventory/inventory-cons-matches/inventory-cons-matches.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;AACJ;AACI;EACI,qBAAA;AACR;AAAQ;EACI,qBAAA;AAEZ","sourcesContent":[".warehouse-transfers-wrap{\n    position: relative;\n    width: auto;\n    display: block;\n    padding: 30px;\n    //margin:-30px;\n    .thirty-padding{\n        padding:0!important;\n        .cp-lg-obj-wrap{\n            padding:0!important;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
